import UserOverTimeChart from "./UserOverTimeChart";
import UserAgeDistributionChart from "./UserAgeDistributionChart";
import UserGenderDistributionChart from "./UserGenderDistributionChart";

export default function UserTable({ userData }) {
    return (
        <div className="p-6 bg-white rounded-lg shadow-md m-5">
            {/* Row for User Growth */}
            <div className="mb-6">
                <UserOverTimeChart userData={userData} />
            </div>

            {/* Row for Age Distribution and Gender Distribution */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="col-span-1">
                    <UserAgeDistributionChart userData={userData} />
                </div>
                <div className="col-span-1">
                    <UserGenderDistributionChart userData={userData} />
                </div>
            </div>
        </div>
    );
}
